<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'General',
          fields: [
            ...this.getCommonFields(),
            new fields.WYSIWYG({
              label: 'Title',
              modelPath: [this, 'form', 'title'],
              multilingual: true,
              required: true
            }),
            new fields.WYSIWYG({
              label: 'Text',
              modelPath: [this, 'form', 'text'],
              multilingual: true,
              required: true
            })
          ]
        }
      ]
    }
  }
}
</script>
